<template>
  <div class="blk_consultation">
    <div class="consultation_photo"><img src="/assets/img/common/img_doctor.png" alt=""></div>
    <p class="consultation_title">ご予約・ご相談は<br>お気軽に</p>
    <p class="consultation_text">歯のことでお悩みでしたら、川崎市中原区にある{{ clinicName }}まで、お気軽にお問い合わせください。</p>
    <p class="consultation_keywords">{{ clinicKeyword }}</p>
    <ReservedBtns :mail="mail"/>
    <dl class="clinic_open">
      <dt>診療時間</dt>
      <dd class="clinic_time">{{ clinicTime }}</dd>
      <dt>休診日</dt>
      <dd class="clinic_holiday">{{ clinicClose }}</dd>
      <template v-for="(exp, idx) in clinicExps">
      <dd :key="idx" class="clinic_short_time">{{ exp.text }}</dd>
      </template>
    </dl>
  </div>
</template>

<script>
import ReservedBtns from '../molcules/reserved_btns.vue'

import { mapState } from 'vuex'

export default {
  name: 'Consultation',
  components: {
    ReservedBtns
  },
  props: {
    mail: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ]),
    clinicName () {
      return this.siteData.info.clinic_name
    },
    clinicTime () {
      return this.siteData.detail.treatment.map(t => t.time).join(' / ')
    },
    clinicKeyword () {
      return this.siteData.detail.keyword.join(' / ')
    },
    clinicClose () {
      return this.siteData.detail.treatment_detail.close
    },
    clinicExps () {
      return this.siteData.detail.treatment_detail.exceptions
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
